import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    /**
     * @description 取得mixTag
     */
    mixTagSearch({ commit }, query) {
        return request.post('/admin/mixtag/search', query)
    },
    /**
     * @description mixTag 儲存
     */
    mixTagStore({ commit }, query) {
        return request.post('/admin/mixtag/store', query)
    },
    /**
     * @description mixTag刪除
     */
    mixTagRemove({ commit }, query) {
        return request.post('/admin/mixtag/remove', query)
    },
}
